import { useSelector } from 'react-redux';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';
import useOpenInDarwin from '@makemydeal/dr-dash-store/hooks/useOpenInDarwin';
import { Button } from '@interstate/components/Button';
import { VppFooterWrapper } from './VehicleProtectionFlyOutCardUI.style';
import { ArrowTopRightOnSquareIcon } from '@interstate/components/Icons';
import { getCurrentOfferType } from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { OFFER_TYPE } from '@makemydeal/dr-platform-types';
import { useVehicleProtectionContext } from '../../context/VehicleProtectionContext';

export type VehicleProtectionFlyOutCardFooterProps = {
    onClose?: () => void;
};

const VehicleProtectionFlyOutCardFooter = ({ onClose }: VehicleProtectionFlyOutCardFooterProps) => {
    const isMvLiteEnabled = useSelector(dealerSelectors.isMvLiteEnabled);
    const isDarwinEnabled = useSelector(dealerSelectors.isDarwinEnabled);
    const enablePushToDarwin = useSelector(featureToggleSelectors.isPushToDarwinEnabled) && isDarwinEnabled && !isMvLiteEnabled;
    const currentOfferType = useSelector(getCurrentOfferType);
    const { isDarwinVppEditGuardEnabled } = useVehicleProtectionContext();
    const showOpenInDarwin = currentOfferType !== OFFER_TYPE.balloon && (enablePushToDarwin || isDarwinVppEditGuardEnabled);

    const handleOpenInDarwin = useOpenInDarwin();

    return (
        <VppFooterWrapper>
            {showOpenInDarwin && (
                <Button
                    data-testid="open-in-darwin-button"
                    buttonStyle="secondary"
                    startIcon={<ArrowTopRightOnSquareIcon />}
                    onClick={handleOpenInDarwin}
                >
                    Open In Darwin
                </Button>
            )}
            <Button data-testid="return-to-offer-button" buttonStyle="secondary" onClick={onClose}>
                Return to Offer
            </Button>
        </VppFooterWrapper>
    );
};

export default VehicleProtectionFlyOutCardFooter;
``;
